import { createSvgIcon } from '@material-ui/core';

export const DownloadIcon = createSvgIcon(
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17 5H32V18.5H41L24.5 35L8 18.5H17V5ZM41 44V39.5H8V44H41Z"
      fill="currentColor"
    />
  </svg>,
  'DownloadIcon',
);
